import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M10.25 5C10.25 4.58579 9.91421 4.25 9.5 4.25C9.08579 4.25 8.75 4.58579 8.75 5V5.75H8C7.58579 5.75 7.25 6.08579 7.25 6.5C7.25 6.91421 7.58579 7.25 8 7.25H8.75V8C8.75 8.41421 9.08579 8.75 9.5 8.75C9.91421 8.75 10.25 8.41421 10.25 8V7.25H11C11.4142 7.25 11.75 6.91421 11.75 6.5C11.75 6.08579 11.4142 5.75 11 5.75H10.25V5ZM18.7374 5.67678C18.054 4.99336 16.946 4.99336 16.2626 5.67678L13.2197 8.71967L5.67678 16.2626C4.99336 16.946 4.99336 18.054 5.67678 18.7374L6.76256 19.8232C7.44598 20.5066 8.55402 20.5066 9.23744 19.8232L16.7803 12.2803L19.8232 9.23744C20.5066 8.55402 20.5066 7.44598 19.8232 6.76256L18.7374 5.67678ZM17.3232 6.73744C17.4209 6.63981 17.5791 6.63981 17.6768 6.73744L18.7626 7.82322C18.8602 7.92085 18.8602 8.07915 18.7626 8.17678L16.25 10.6893L14.8107 9.25L17.3232 6.73744ZM13.75 10.3107L15.1893 11.75L8.17678 18.7626C8.07914 18.8602 7.92085 18.8602 7.82322 18.7626L6.73744 17.6768C6.63981 17.5791 6.63981 17.4209 6.73744 17.3232L13.75 10.3107ZM6 11C6 11.5523 5.55228 12 5 12C4.44772 12 4 11.5523 4 11C4 10.4477 4.44772 10 5 10C5.55228 10 6 10.4477 6 11ZM18.5 15.25C18.9142 15.25 19.25 14.9142 19.25 14.5C19.25 14.0858 18.9142 13.75 18.5 13.75C18.0858 13.75 17.75 14.0858 17.75 14.5C17.75 14.9142 18.0858 15.25 18.5 15.25Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
